import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from '@mui/material/styles';
const Root = styled('div')(({ theme }) => ({
    display: 'flex',
    width: '100%',
    height: '100%',
    backgroundColor: theme.palette.background.paper,
}));
const FullPage = ({ children }) => _jsx(Root, { children: children });
export default FullPage;
//# sourceMappingURL=index.js.map